export default "/banner.d9e1870e-9d83b6.png";